import { useRecoilState, useRecoilValue } from "recoil";
import { HandleHelp, scaleValue, thumnail } from "../atoms";
import { useControls } from "react-zoom-pan-pinch";
import { useEffect, useState } from "react";
import {
  IconButton,
  Input,
  InputAdornment,
  Tooltip,
  useMediaQuery,
} from "@mui/material";

import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import FitScreenIcon from "@mui/icons-material/FitScreen";
import styled from "styled-components";
import ZoomOut from "./menuComponent/ZoomOut";
import ZoomIn from "./menuComponent/ZoomIn";
import Thumnail from "./menuComponent/Thumnail";
import Contact from "./menuComponent/Contact";
import CenterView from "./menuComponent/CenterView";
import List from "./menuComponent/List";
import ZoomValueInput from "./menuComponent/ZoomValueInput";
import HelpIcon from "@mui/icons-material/Help";

const IconBox = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
function Menu() {
  const scale = useRecoilValue(scaleValue);
  const { zoomIn, zoomOut, centerView } = useControls();
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [zoomValue, setZoomValue] = useRecoilState(scaleValue);
  const [openThumnail, setOpenThumnail] = useRecoilState(thumnail);
  const [showHelp, setShowHelp] = useRecoilState(HandleHelp);

  const isMobile = useMediaQuery("(max-width: 768px)");

  const fullScreenMode = (direction, e) => {
    if (direction === "full") document.documentElement.requestFullscreen();
    else document.exitFullscreen();
    e.currentTarget.blur();
    setIsFullScreen((prev) => !prev);
    screenRate(e);
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const screenRate = (e) => {
    e.currentTarget.blur();
    if (!isMobile) {
      if (window.innerWidth > window.innerHeight) {
        centerView(
          window.innerWidth / window.innerHeight - 0.2,
          100,
          "easeOut"
        );
      } else {
        centerView(
          window.innerHeight / window.innerWidth - 0.2,
          100,
          "easeOut"
        );
      }
    }
  };
  return (
    <>
      <div
        style={{
          width: "25%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src="https://webfile.mempro.co.kr/image/logo/logo.svg"
          height={25}
        />
      </div>

      <IconBox $isMobile={isMobile}>
        <ZoomOut />
        {/* <button onClick={() => zoomOut(0.2, 100, "easeOut")}>ZoomOut</button> */}
        {/* <input value={Math.round((scale * 100) / 10) * 10} disabled />% */}
        <ZoomValueInput />
        {/* <button onClick={() => zoomIn(0.2, 100, "easeOut")}>ZoomIn</button>\ */}
        <ZoomIn />
        {!isMobile && (
          <Tooltip title={isFullScreen ? "Window" : "Full Screen"}>
            <IconButton
              aria-label="full"
              color="primary"
              onClick={(e) => {
                fullScreenMode(isFullScreen ? "window" : "full", e);
              }}
              sx={{ marginRight: 2 }}
            >
              {isFullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
            </IconButton>
          </Tooltip>
          // <button
          //   onClick={() => fullScreenMode(isFullScreen ? "window" : "full")}
          // >
          //   {isFullScreen ? "Window" : "Full"}
          // </button>
        )}
        <Thumnail />
        {/* <button onClick={() => setOpenThumnail((prev) => !prev)}>Thumnail</button> */}
        <Contact />
        {/* <button onClick={goToContact}>Contact</button> */}
        <CenterView />
        {
          !isMobile && (
            <Tooltip title="Fit Screen">
              <IconButton
                aria-label="fitScreen"
                color="primary"
                onClick={(e) => screenRate(e)}
                sx={{ marginRight: 2 }}
              >
                <FitScreenIcon />
              </IconButton>
            </Tooltip>
          )
          // <button onClick={screenRate}>Rate</button>
        }
        <List />
      </IconBox>
      <div
        style={{
          width: "25%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Tooltip title="help">
          <HelpIcon
            color="primary"
            sx={{ cursor: "pointer" }}
            onClick={() => setShowHelp((prev) => !prev)}
          />
        </Tooltip>
      </div>
    </>
  );
}

export default Menu;
